import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import AdministratorSettings from '../../components/admin/settings/AdminSettings';

const AdminSettings = () => {
  return (
    <AdminLayout>
      <AdministratorSettings />
    </AdminLayout>
  );
};

export default AdminSettings;